import { MY_LOCATION_FETCH_REQUEST, MY_LOCATION_FETCH_SUCCESS, MY_LOCATION_FETCH_FAILURE } from './types';
import baseUrl from '../url'

const fetchLocationRequest = () => {
    return {
        type: MY_LOCATION_FETCH_REQUEST
    }
}

const fetchLocationSuccess = locations => {
    return {
        type: MY_LOCATION_FETCH_SUCCESS,
        payload: locations,
    }
}

const fetchLocationFailure = error => {
    return {
        type: MY_LOCATION_FETCH_FAILURE,
        payload: error,
    }
}

export const getMylocations = () => {
    return (dispatch) => {
        const token = localStorage.getItem('token');
        dispatch(fetchLocationRequest());
        fetch(`${baseUrl}/addresses`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            .then(response => response.json())
            .then((response) => {
                dispatch(fetchLocationSuccess(response))
            })
            .catch((error) => {
                dispatch(fetchLocationFailure(error.message));
            })
    }
}